import { useEffect } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { devLog, devError, devWarn } from "@/lib/utils";

const SessionManager = ({ children }) => {
  const { user, restoreSession, clearAuthSession } = useAuth();

  useEffect(() => {
    // 페이지 새로고침 감지
    const handleBeforeUnload = () => {
      // 사용자가 로그인되어 있다면 새로고침 전에 세션 정보 확인
      if (user) {
        devLog("Page refresh detected - session preserved");
      }
    };

    // 페이지 로드 완료 시 세션 복원 시도
    const handlePageLoad = async () => {
      const accessToken = sessionStorage.getItem("accessToken");
      const savedUser = sessionStorage.getItem("user");

      // 토큰이 있지만 현재 user 상태가 없다면 복원 시도
      if (accessToken && savedUser && !user) {
        devLog("Page loaded - attempting session restore");
        try {
          const restored = await restoreSession();
          if (!restored) {
            devLog("Session restoration failed - clearing session");
            clearAuthSession();
          }
        } catch (error) {
          devError("Session restoration error:", error);
          clearAuthSession();
        }
      }
    };

    // 이벤트 리스너 등록
    window.addEventListener("beforeunload", handleBeforeUnload);
    window.addEventListener("load", handlePageLoad);

    // 컴포넌트 마운트 시 즉시 세션 확인
    handlePageLoad();

    // 정리
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
      window.removeEventListener("load", handlePageLoad);
    };
  }, [user, restoreSession, clearAuthSession]);

  return children;
};

export default SessionManager;
